import type { MstCommon } from '@libs/domain';
import { dateToStr } from '@ps-smart-cp/ppfw-client';
import type { DateRangeObject, WithBlankSearchObject, WithExclusionObject } from '@ps-smart-cp/ppfw-client';

export class MstListSearch
  implements
    Pick<
      MstCommon['schema'],
      | 'codeRange'
      | 'mstNoteCondition'
      | 'mstSpareName01Condition'
      | 'mstSpareName02Condition'
      | 'name'
      | 'validityEndDateCondition'
      | 'validityStartDateCondition'
    >
{
  protected constructor(
    readonly codeRange: WithExclusionObject,
    readonly name: string,
    readonly mstSpareName01Condition: WithBlankSearchObject,
    readonly mstSpareName02Condition: WithBlankSearchObject,
    readonly validityStartDateCondition: DateRangeObject,
    readonly validityEndDateCondition: DateRangeObject,
    readonly mstNoteCondition: WithBlankSearchObject,
  ) {}

  static baseInit() {
    return new MstListSearch(
      { body: '', isExcluded: false },
      '',
      { body: '', isBlankOnly: false },
      { body: '', isBlankOnly: false },
      { from: null, to: null },
      { from: null, to: null },
      { body: '', isBlankOnly: false },
    );
  }
}

export class MstListSearchRaw
  implements
    Pick<
      MstCommon['record'],
      | 'codeRange'
      | 'isCodeRangeExcluded'
      | 'isMstNoteBlankOnly'
      | 'isMstSpareName01BlankOnly'
      | 'isMstSpareName02BlankOnly'
      | 'mstNote'
      | 'mstSpareName01'
      | 'mstSpareName02'
      | 'name'
      | 'validityEndDateFrom'
      | 'validityEndDateTo'
      | 'validityStartDateFrom'
      | 'validityStartDateTo'
    >
{
  protected constructor(
    readonly codeRange: string,
    readonly isCodeRangeExcluded: boolean,
    readonly name: string,
    readonly mstSpareName01: string,
    readonly isMstSpareName01BlankOnly: boolean,
    readonly mstSpareName02: string,
    readonly isMstSpareName02BlankOnly: boolean,
    readonly validityStartDateFrom: string,
    readonly validityStartDateTo: string,
    readonly validityEndDateFrom: string,
    readonly validityEndDateTo: string,
    readonly mstNote: string,
    readonly isMstNoteBlankOnly: boolean,
  ) {}

  static baseFromModel({
    codeRange,
    name,
    mstSpareName01Condition,
    mstSpareName02Condition,
    validityStartDateCondition,
    validityEndDateCondition,
    mstNoteCondition,
  }: MstListSearch): MstListSearchRaw {
    return new MstListSearchRaw(
      codeRange.body,
      codeRange.isExcluded,
      name,
      mstSpareName01Condition.body,
      mstSpareName01Condition.isBlankOnly,
      mstSpareName02Condition.body,
      mstSpareName02Condition.isBlankOnly,
      dateToStr(validityStartDateCondition.from, 'yyyyMMdd'),
      dateToStr(validityStartDateCondition.to, 'yyyyMMdd'),
      dateToStr(validityEndDateCondition.from, 'yyyyMMdd'),
      dateToStr(validityEndDateCondition.to, 'yyyyMMdd'),
      mstNoteCondition.body,
      mstNoteCondition.isBlankOnly,
    );
  }
}
